export default __webpack_public_path__ + "static/media/j-scott-rumptz_2.eafedaf4.jpg";